export const mediaSizes = {
    xs: '480px',
    sm:'640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
};

export const maxContainerWidth = '1536px';

export const narrowContainerWidth = '1120px';
export const narrowContainerPaddingMobile = '1rem';
export const narrowContainerPaddingDesktop = '3.625rem';

export const pageContainerStyles = `
  width: 100%;
  max-width: ${maxContainerWidth};
  margin-inline: auto;
  padding-inline: 1rem;

  @media (width >= ${mediaSizes.md}) {
    padding-inline: 3.625rem;
  }
`;

export const narrowPageContainerStyles = `
  width: 100%;
  max-width: ${narrowContainerWidth};
  margin-inline: auto;
  padding-inline: ${narrowContainerPaddingMobile};

  @media (width >= ${mediaSizes.md}) {
    padding-inline: ${narrowContainerPaddingDesktop};
  }
`;

export const responsivePaddingX = {
  desktop: '80px',
  lg: '40px',
  md: '24px',
  xs: '16px'
};

export const fullWidthContainerStyles = `
  max-width: 100%;
  padding: 0 80px;

  @media (max-width: ${mediaSizes.lg}) {
    padding: 0 40px;
  }

  @media (max-width: ${mediaSizes.md}) {
    padding: 0 24px;
  }

  @media (max-width: ${mediaSizes.xs}) {
    padding: 0 16px;
  }
`;



